import { render, staticRenderFns } from "./CampaignsAssignUsers.vue?vue&type=template&id=21d08bab&scoped=true&"
import script from "./CampaignsAssignUsers.vue?vue&type=script&lang=js&"
export * from "./CampaignsAssignUsers.vue?vue&type=script&lang=js&"
import style0 from "./CampaignsAssignUsers.vue?vue&type=style&index=0&id=21d08bab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d08bab",
  null
  
)

export default component.exports